module.exports = __webpack_public_path__ + "assets/grader.svg?5cbb18c5f5b1f7176ac5b4a3de479d07";